

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchDistricts } from "../redux/actions/districtsActions";
// import theme from "../components/shared/theme";
// import { thStyle, tdStyle } from "../components/shared/themeStyles";
// import EditDistrictModal from "../pages/Districts/EditDistrictModal";

// const ViewDistricts = () => {
//   const dispatch = useDispatch();
//   const { districts = [], loading, error } = useSelector((state) => state.districtsData);

//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedDistrict, setSelectedDistrict] = useState(null);

//   useEffect(() => {
//     dispatch(fetchDistricts());
//   }, [dispatch]);

//   const handleEdit = (district) => {
//     setSelectedDistrict(district);
//     setShowEditModal(true);
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         padding: theme.spacing.md,
//         minHeight: "100vh",
//       }}
//     >
//       <h1
//         style={{
//           fontSize: theme.font.size["2xl"],
//           fontWeight: theme.font.weight.bold,
//           marginBottom: theme.spacing.md,
//         }}
//       >
//         Districts List
//       </h1>

//       {loading ? (
//         <p style={{ fontSize: theme.font.size.base }}>Loading districts...</p>
//       ) : error ? (
//         <div
//           style={{
//             backgroundColor: theme.colors.dangerLight,
//             border: `1px solid ${theme.colors.danger}`,
//             color: theme.colors.dangerText,
//             padding: theme.spacing.sm,
//             borderRadius: theme.radius.md,
//             marginBottom: theme.spacing.md,
//           }}
//         >
//           Error: {error}
//         </div>
//       ) : districts.length > 0 ? (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-[400px] w-full text-sm text-left">
//             <thead
//               style={{
//                 backgroundColor: theme.colors.grayDark,
//                 color: "white",
//               }}
//             >
//               <tr>
//                 <th style={thStyle}>#</th>
//                 <th style={thStyle}>District Name</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {districts.map((dist, index) => (
//                 <tr key={dist.id} className="hover:bg-gray-50">
//                   <td style={tdStyle}>{index + 1}</td>
//                   <td style={tdStyle}>{dist.name}</td>
//                   <td style={tdStyle}>
//                     <button
//                       onClick={() => handleEdit(dist)}
//                       className="text-blue-600 hover:underline"
//                     >
//                       Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p style={{ fontSize: theme.font.size.base }}>No districts found.</p>
//       )}

//       {/* Modal */}
//       {showEditModal && selectedDistrict && (
//         <EditDistrictModal
//           district={selectedDistrict}
//           onClose={() => setShowEditModal(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default ViewDistricts;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDistricts } from "../redux/actions/districtsActions";
import theme from "../components/shared/theme";
import { thStyle, tdStyle } from "../components/shared/themeStyles";
import EditDistrictModal from "../pages/Districts/EditDistrictModal";

const ViewDistricts = () => {
  const dispatch = useDispatch();
  const { districts = [], loading, error } = useSelector((state) => state.districtsData);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState(null);

  useEffect(() => {
    dispatch(fetchDistricts());
  }, [dispatch]);

  const handleEdit = (district) => {
    setSelectedDistrict(district);
    setShowEditModal(true);
  };

  const handleDownloadCSV = () => {
    if (districts.length === 0) return;

    const csvHeader = ["ID", "District Name"];
    const csvRows = districts.map((dist, index) => [
      index + 1,
      `"${dist.name.replace(/"/g, '""')}"`,
    ]);

    const csvContent = [csvHeader, ...csvRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "districts.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        padding: theme.spacing.md,
        minHeight: "100vh",
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <h1
          style={{
            fontSize: theme.font.size["2xl"],
            fontWeight: theme.font.weight.bold,
          }}
        >
          Districts List
        </h1>
        <button
          onClick={handleDownloadCSV}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          Download CSV
        </button>
      </div>

      {loading ? (
        <p style={{ fontSize: theme.font.size.base }}>Loading districts...</p>
      ) : error ? (
        <div
          style={{
            backgroundColor: theme.colors.dangerLight,
            border: `1px solid ${theme.colors.danger}`,
            color: theme.colors.dangerText,
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
            marginBottom: theme.spacing.md,
          }}
        >
          Error: {error}
        </div>
      ) : districts.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[400px] w-full text-sm text-left">
            <thead
              style={{
                backgroundColor: theme.colors.grayDark,
                color: "white",
              }}
            >
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>District Name</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {districts.map((dist, index) => (
                <tr key={dist.id} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{dist.name}</td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => handleEdit(dist)}
                      className="text-blue-600 hover:underline"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ fontSize: theme.font.size.base }}>No districts found.</p>
      )}

      {/* Modal */}
      {showEditModal && selectedDistrict && (
        <EditDistrictModal
          district={selectedDistrict}
          onClose={() => setShowEditModal(false)}
        />
      )}
    </div>
  );
};

export default ViewDistricts;
